import ShoppingLists from './shopping_lists'

export default ShoppingLists
